import { useState } from 'react';
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

export default function IMGSViewer({imgs, vista, active}) {

    return (
        <div className={`pane imgs ${active ? 'active' : ''}`}>
            <ImageGallery items={imgs} />
        </div>
    );
};
